export enum AutomatedWizardStatus {
  CREATING_CONFIGURATION = 'CREATING_CONFIGURATION',
  CREATING_PROJECT = 'CREATING_PROJECT',
  FINISHED = 'FINISHED',
}
